import * as C from '../common/constants';
import Button from './Button';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import InputComponent from './InputComponent';
import MuiDialogContent from '@mui/material/DialogContent';
import React, { useRef } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      closeButtonStyle: {
        position: 'absolute',
        right: 20, // theme.spacing(2),
        top: 20, // theme.spacing(2),
        fill: COLORS.textGray,
        width: '40px',
        height: '40px',
        pointerEvents: 'auto',
        zIndex: 100,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContentStyle: {
        display: 'flex',
        flexDirection: 'column',
        margin: '16px',
        color: COLORS.textBlack,
        padding: '30px',
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: FONTS.alegreya,
        alignItems: 'center',
      },
      sendButtonStyle: {
        marginTop: '16px',
        width: '190px',
      },
      inputStyle: {
        width: '100%',
        minWidth: '400px',
        padding: '6px 10px',
        marginTop: '10px',
      },
    })
);

const UploadComment = ({ onClose, fileUUid, onAddComment, comment }) => {
  const classes = useStyles();
  const inputRef = useRef<any>();

  const addLabel = useTranslations('add_image');
  const addPlaceholder = useTranslations('add_image_placeholder');

  const isMobile = window.innerWidth < 900;

  const options = {
    safeName: fileUUid,
  };

  const onAddSave = (event: any) => {
    event.stopPropagation();
    event.preventDefault();

    const newComment = inputRef.current.value;

    onAddComment(fileUUid, newComment);
    onClose();
  };

  return (
    <Dialog
      fullScreen={isMobile}
      open={Boolean(fileUUid)}
      onClose={onClose}
      className={classes.dialogContainerStyle}
    >
      <CloseIcon className={classes.closeButtonStyle} onClick={onClose} />
      <MuiDialogContent className={classes.dialogContentStyle}>
        <>
          <InputComponent
            value={comment}
            className={classes.inputStyle}
            placeholder={addPlaceholder}
            dataName={'comment'}
            options={options}
            passedRef={inputRef}
            maxLength={C.MAX_IMAGE_DESCRIPTION}
            isRemainingVisible
          />
          <Button
            onClick={onAddSave}
            text={addLabel}
            className={classes.sendButtonStyle}
          />
        </>
      </MuiDialogContent>
    </Dialog>
  );
};

export default UploadComment;
